import { URLS } from '@wix/da-url';
import FacebookIcon from '@wix/da-ds/pkg/Icons/Facebook';
import InstagramIcon from '@wix/da-ds/pkg/Icons/Instagram';
import TwitterIcon from '@wix/da-ds/pkg/Icons/Twitter';

export const menuItems = [
  { key: 'siteFooter.menu.about', href: URLS.ABOUT, name: 'about' },
  { key: 'siteFooter.menu.contact', href: URLS.CONTACT, name: 'contact' },
  {
    key: 'siteFooter.menu.coreMembership',
    href: URLS.CORE_MEMBERSHIP,
    name: 'core_membership',
  },
  {
    key: 'siteFooter.menu.sellYourArt',
    href: URLS.SHOP_TOP_NAV,
    name: 'sellYourArt',
  },
  {
    key: 'siteFooter.menu.developers',
    href: URLS.DEVELOPERS,
    name: 'developers',
  },
  { key: 'siteFooter.menu.advertise', href: URLS.ADVERTISE, name: 'advertise' },
  {
    key: 'siteFooter.menu.termsOfService',
    href: URLS.TOS,
    name: 'terms_of_service',
  },
  { key: 'siteFooter.menu.etiquette', href: URLS.ETIQUETTE, name: 'etiquette' },

  { key: 'siteFooter.menu.careers', href: URLS.CAREERS, name: 'careers' },
  { key: 'siteFooter.menu.privacyPolicy', href: URLS.PRIVACY, name: 'privacy' },
  {
    key: 'siteFooter.menu.copyrightPolicy',
    href: URLS.COPYRIGHT,
    name: 'copyright',
  },
  { key: 'siteFooter.menu.helpAndFaq', href: URLS.HELP, name: 'help' },
];

export const socialButtons = [
  {
    icon: FacebookIcon,
    href: URLS.DEVIANTART_FACEBOOK,
    title: 'DeviantArt Facebook',
    name: 'facebook',
  },
  {
    icon: TwitterIcon,
    href: URLS.DEVIANTART_TWITTER,
    title: 'DeviantArt X',
    name: 'twitter',
  },
  {
    icon: InstagramIcon,
    href: URLS.DEVIANTART_INSTAGRAM,
    title: 'DeviantArt Instagram',
    name: 'instagram',
  },
];
